// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploadPicture[data-v-6c48a716] {\n  padding: 0 12px 15px 12px;\n  border-bottom: 1px solid #eee;\n}\n.uploadPicture .title[data-v-6c48a716] {\n  color: #282828;\n  font-size: 15px;\n  padding-top: 14px;\n}\n.uploadPicture .list .pictrue[data-v-6c48a716] {\n  width: 74px;\n  height: 74px;\n  margin: 10px 10px 0 0;\n}\n.uploadPicture .list .pictrue img[data-v-6c48a716] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
